var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.officeReady)?[(_vm.auth && _vm.auth.userId)?_c('div',[_c('router-view')],1):_c('div',[_c('LoginForm')],1)]:[_c('SideloadAddinMsg')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }